export default __webpack_public_path__ + "static/media/img_introduce_company_2.14611a03.png";